import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import { LoadingSpinner } from "@/Layouts/components/LoadingSpinner";
import { Box, Fade, Stack } from "@mui/material";

interface ISalesPerformanceTableTitleProps {
	onUseSwitch?: (value: boolean) => void;
	useSwitch?: boolean;
	operational?: boolean;
	isLoading?: boolean;
}

export const SalesPerformanceTableTitle = (props: Readonly<ISalesPerformanceTableTitleProps>) => {
	const { operational, isLoading, useSwitch, onUseSwitch } = props;

	return (
		<Stack direction="column" marginTop={1} justifyContent="flex-start" flex={1}>
			{useSwitch && (
				<Box alignContent="center" className="h-10 max-w-40">
					<CustomizedSwitches
						textRight={true}
						textChecked="Operational"
						textUnChecked="Commissionable"
						checked={operational}
						onChange={(value) => onUseSwitch?.(value)}
					/>
				</Box>
			)}

			<Fade timeout={400} in={isLoading} unmountOnExit>
				<div>
					<LoadingSpinner label="Loading Sales Performance..." className="items-center" />
				</div>
			</Fade>
		</Stack>
	);
};
